const BQ_YOUTUBE_LINK:string = "https://www.youtube.com/@bqyoutube"
const BQ_TWITTER_LINK:string = "https://twitter.com/bqyoutube"
const BQ_TELEGRAM_LINK:string = "https://t.me/BQTelegram"

export {
    BQ_YOUTUBE_LINK,
    BQ_TWITTER_LINK,
    BQ_TELEGRAM_LINK
}